import { render, staticRenderFns } from "./TermoAceiteLogin.vue?vue&type=template&id=4ed1c51f&lang=html&"
import script from "./TermoAceiteLogin.vue?vue&type=script&lang=js&"
export * from "./TermoAceiteLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/termo-aceite/TermoAceiteLogin.vue
// module id = 958
// module chunks = 28